'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _imageDetail = require('./imageDetail/imageDetail');

var _imageDetail2 = _interopRequireDefault(_imageDetail);

var _confirmDialog = require('./confirmDialog/confirmDialog');

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _reportImages = require('./reportImages/reportImages');

var _reportImages2 = _interopRequireDefault(_reportImages);

var _reportMap = require('./reportMap/reportMap');

var _reportMap2 = _interopRequireDefault(_reportMap);

var _flora = require('../services/floraService/flora');

var _flora2 = _interopRequireDefault(_flora);

var _model = require('./factories/modelFactory/model');

var _model2 = _interopRequireDefault(_model);

var _dynamicModel = require('./directive/dynamicModel/dynamicModel');

var _dynamicModel2 = _interopRequireDefault(_dynamicModel);

var _isNumericArray = require('./directive/isNumericArray/isNumericArray');

var _isNumericArray2 = _interopRequireDefault(_isNumericArray);

var _language = require('./factories/languageFactory/language');

var _language2 = _interopRequireDefault(_language);

var _dots = require('./filters/dotsFilter/dots');

var _dots2 = _interopRequireDefault(_dots);

var _noHTML = require('./filters/noHTML/noHTML');

var _noHTML2 = _interopRequireDefault(_noHTML);

var _camelToKebab = require('./filters/camelToKebabService/camelToKebab');

var _camelToKebab2 = _interopRequireDefault(_camelToKebab);

var _snakeToSpace = require('./filters/snakeToSpaceService/snakeToSpace');

var _snakeToSpace2 = _interopRequireDefault(_snakeToSpace);

var _resource = require('../services/resourceService/resource');

var _resource2 = _interopRequireDefault(_resource);

var _user = require('../services/userService/user');

var _user2 = _interopRequireDefault(_user);

var _auth = require('../services/authService/auth');

var _auth2 = _interopRequireDefault(_auth);

var _information = require('../services/informationService/information');

var _information2 = _interopRequireDefault(_information);

var _geojsonBuilder = require('../services/geojsonBuilder/geojsonBuilder');

var _geojsonBuilder2 = _interopRequireDefault(_geojsonBuilder);

var _util = require('../services/utilService/util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_imageDetail2.default, _confirmDialog2.default, _flora2.default, _dots2.default, _noHTML2.default, _camelToKebab2.default, _snakeToSpace2.default, _model2.default, _language2.default, _dynamicModel2.default, _isNumericArray2.default, _resource2.default, _user2.default, _auth2.default, _information2.default, _geojsonBuilder2.default, _util2.default, _reportImages2.default, _reportMap2.default]).name;

exports.default = commonModule;


// WEBPACK FOOTER //
// ./client/app/common/common.js